import GiftBlueLineIcon from './ic_gift_blue_line.svg';
import LoudSpeakerCircleIcon from './ic_loud_speaker_circle.svg';

export { GiftBlueLineIcon, LoudSpeakerCircleIcon };
